import { AppLayout } from "../../components/layout/Header";
import { MessagesDesk } from "../../components/messaging";

export default function AgentMessages() {
  return (
    <AppLayout variant="agent">
      <MessagesDesk deskRole="agent" />
    </AppLayout>
  );
}
